module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/ko/3-70803d2d753e4db76961cb14020fe09e.jpg";